import { CommonKeys } from "../../../common/enums"
import { META_PROTOCOLS_TYPE } from "../../../common/formular-group-types"

export const FormularModelMetaProtocolsSchema = {
    $id: "FormularModelMetaProtocolsSchema",
    title: "FormularModelMetaProtocols Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: META_PROTOCOLS_TYPE },
        LastChangedDate: { type: "string", nullable: true },
        CustomerSignedDate: { type: "string", nullable: true }
    }
}